import Factory from '../factory';

const schema = Factory.schema('hero-carousel');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('category').setType(String).setValue('Category');
attributes.prop('heading').setType(String).setValue('Heading');
attributes.prop('text').setType(String).setValue('Text...');
attributes.prop('btnText').setType(String).setValue('Find out more');
attributes.prop('imgSrc').setType(String).setValue('image-placeholder-square.svg');

export default schema;
